import * as React from 'react';
import { styled } from '@mui/material/styles';
import { Avatar, Box, Button, Card, CardActionArea, CardContent, Divider, Typography } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import { ShoppingCartProductsContext } from '../../contexts/ShoppingCartProductsContext';
import { useContext } from 'react';
import { currency } from '../../components/building_blocks/Currency';

const Content = styled(CardContent)({
  display: 'flex', justifyContent: 'flex-start', alignItems: 'center', padding: '8px'
});

const ShoppingCartElement = () => {
  const { totalAmount } = useContext(ShoppingCartProductsContext);
  const { totalQuantity } = useContext(ShoppingCartProductsContext);

  const navigate = useNavigate();

  if (totalAmount && window.location.href.indexOf("shopping-cart") === -1) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'flex-start', position: 'relative', alignItems: 'center', width: '100%', maxWidth: 'md',  paddingTop: '54px' }}>
        <Card alignItems="flex-start" sx={{ display: "flex", width: 'calc(100% - 32px)', opacity: '0.95', height: '54px', borderRadius: '4px', position: 'fixed', bottom: '72px', zIndex: '9999', left: '16px', right: '16px' }}>
          <Box sx={{ marginTop: '8px', marginLeft: '8px' }}>
            <Typography textAlign="left" variant="body2" sx={{ fontSize: '13px' }}>
              <b>Total</b>
            </Typography>
            <Typography textAlign="left" sx={{ fontSize: '13px' }} color="gray">
              {currency(totalAmount)} / {totalQuantity} itens
            </Typography>
          </Box>
          <Box sx={{ marginLeft: 'auto', marginRight: '12px', alignSelf: 'center' }}>
            <Button variant="contained" type="button" onClick={() => { navigate('/shopping-cart'); window.scrollTo(0, 0); }}>Ver carrinho</Button>
          </Box>
        </Card>
      </Box>
    );
  }
};

export default ShoppingCartElement;
